export default __webpack_public_path__ + "static/media/regulatory--turn-left-or-right--g3.0bee4d0c.png";